module.exports = __webpack_public_path__ + "img/text_1.75a33d94.png";